module.exports = __webpack_public_path__ + "img/cover8.aeee3eda.jpeg";